import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import findResult from '@/utils/resultsHelper';
import { readStates } from '@/constants/lifecycle';
import useDebounce from '@/utils/debounce';
import { getMemberId } from '@/users/membership/helper';
import MembersPermissionAddRow from '@/users/membership/components/MembersPermissionAddRow';
import {
  addCohortMembers, fetchCohortMembers, updateCohortMembersProperties, updateShareCohortProperties,
} from '../actions';
import { cohortPermissionGroups } from '../constants';

const CohortMemberAddRow = ({
  category,
  code,
  members,
  membersToAdd,
  fetchData,
  updateFilter,
  updateProperties,
  addMembers,
  readStatus,
  filter,
  permission,
  allowSecure,
}) => {
  const debouncedFetch = useDebounce(fetchData);

  const onFilterChange = useCallback((value) => {
    updateFilter(category, code, value);
    debouncedFetch(category, code, value);
  }, [category, code, updateFilter, debouncedFetch]);

  return (
    <MembersPermissionAddRow
      addMembers={() => addMembers(category, code)}
      allowSecure={allowSecure}
      entity="cohort"
      filter={filter}
      members={members}
      membersToAdd={membersToAdd}
      onFilterChange={onFilterChange}
      permission={permission}
      permissionGroups={cohortPermissionGroups}
      readStatus={readStatus}
      updateProperties={updateProperties}
    />
  );
};

const dialogProps = (sharingCohort, exists, members = []) => (
  {
    exists,
    permission: sharingCohort.permissionGroup,
    membersToAdd: sharingCohort.membersToAdd,
    members: sharingCohort.membersToAdd.concat(members),
  }
);

const withoutItem = (sharingCohort) => (
  {
    ...dialogProps(sharingCohort, false),
    ...readStates,
    filter: '',
  }
);

const withItem = (item, sharingCohort) => {
  const members = item.members.results;
  const assignable = item.unassignedMembers.results;
  const memberIds = members.map(getMemberId);

  return (
    {
      ...dialogProps(sharingCohort, true, assignable.filter((member) => (!memberIds.includes(getMemberId(member))))),
      readStatus: item.unassignedMembers.readStatus,
      readErrors: item.unassignedMembers.readErrors,
      filter: item.unassignedMembers.filter,
    }
  );
};

const mapStateToProps = ({
  cohorts: {
    cohorts, sharingCohort,
  },
}, { category, code }) => {
  const item = findResult(cohorts, category, code);
  return item ? withItem(item, sharingCohort) : withoutItem(sharingCohort);
};

const mapDispatchToProps = {
  fetchData: (category, code, filter) => fetchCohortMembers(category, code, true, filter),
  updateFilter: (category, code, filter) => updateCohortMembersProperties(category, code, true, { filter }),
  addMembers: addCohortMembers,
  updateProperties: updateShareCohortProperties,
};

export default connect(mapStateToProps, mapDispatchToProps)(CohortMemberAddRow);
